module.exports = __webpack_public_path__ + "img/warp_beast_temporal_jump.fc6aaded.png";